import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';

// --- Component ---
import { WhatsAppButtonComponent } from './whatsapp-button.component';

@NgModule({
	declarations: [WhatsAppButtonComponent],
	imports: [
		CommonModule,

		// --- PrimeNG ---
		ButtonModule,
	],
	exports: [WhatsAppButtonComponent],
})
export class WhatsAppButtonModule {}
